import { useCallback } from 'react'

import { Space, TransparentIconButton } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { GuidedIntakePromoBannerCtaStyled } from './styles/GuidedIntakePromoBannerStyled'
import { GUIDED_INTAKE_PROMO_EVENTS } from '../../constants'
import { useGuidedIntakePromoDismissal } from '../../hooks/useGuidedIntakePromoDismissal'
import { AiActionBanner } from '../AiActionBanner'

interface IGuidedIntakePromoBannerProps {
  analyticsId: string
  onLearnMoreClick: () => void
}

export const GuidedIntakePromoBanner = ({
  analyticsId,
  onLearnMoreClick,
}: IGuidedIntakePromoBannerProps) => {
  const intl = useProcurifyIntl()
  const { isDismissed, dismiss } = useGuidedIntakePromoDismissal()

  const handleDismissClick = useCallback(() => {
    window.analytics?.track(GUIDED_INTAKE_PROMO_EVENTS.DISMISSED, {
      surface: analyticsId,
    })
    dismiss()
  }, [analyticsId, dismiss])

  if (isDismissed) return null

  return (
    <AiActionBanner
      analyticsId={analyticsId}
      action={
        <Space direction='horizontal' size='small' align='center'>
          <GuidedIntakePromoBannerCtaStyled
            analyticsId={`${analyticsId}-cta`}
            onClick={onLearnMoreClick}
          >
            {intl.formatMessage(messages.learnMore)}
          </GuidedIntakePromoBannerCtaStyled>

          <TransparentIconButton
            icon='times'
            aria-label={intl.formatMessage(messages.dismissAriaLabel)}
            analyticsId={`${analyticsId}-dismiss`}
            onClick={handleDismissClick}
          />
        </Space>
      }
    >
      {intl.formatMessage(messages.bannerText)}
    </AiActionBanner>
  )
}
